import { createApi } from '@reduxjs/toolkit/query/react';

import fetchJwtServiceBaseQuery from '@app/externalApi/fetchJwtServiceBaseQuery';

import type { WhoamiResponse } from './types';

// Define your API
export const identityApi = createApi({
    reducerPath: 'lokaliseInternal_identity',
    baseQuery: fetchJwtServiceBaseQuery(window.env.identityServiceBaseUrl),
    tagTypes: [],
    endpoints: (builder) => ({
        getWhoami: builder.query<WhoamiResponse, void>({
            query: () => ({
                method: 'GET',
                url: '/whoami',
            }),
        }),
    }),
});

export default identityApi;

export const { useGetWhoamiQuery } = identityApi;
